// src/app/rootReducer.js

/**
 * Combines all feature reducers into a single root reducer.
 * Adds support for Redux Persist (for auth), and RTK Query APIs.
 */

import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage for web

// Feature slices
import authReducer from "../features/auth/authSlice";
import userReducer from "../features/auth/userSlice";

// RTK Query APIs
import { userApi } from "../features/auth/userApi";
import { loginApi } from "../features/auth/loginApi";

// Redux Persist configuration for auth slice
const authPersistConfig = {
  key: "auth", // Key under which to persist in localStorage
  storage, // Use default localStorage
  whitelist: ["token", "isAuthenticated"], // Persist only specific fields
};

// Combine all reducers into the root reducer
const rootReducer = combineReducers({
  // Persisted auth reducer
  auth: persistReducer(authPersistConfig, authReducer),

  // Non-persisted user reducer
  user: userReducer,

  // RTK Query API reducers (dynamic keys using reducerPath)
  [userApi.reducerPath]: userApi.reducer,
  [loginApi.reducerPath]: loginApi.reducer,
});

export default rootReducer;
